module.exports = __webpack_public_path__ + "img/curve.510c790a.png";